import { render } from "./QrCodeComponentViewer.vue?vue&type=template&id=636b22f8&scoped=true&ts=true"
import script from "./QrCodeComponentViewer.vue?vue&type=script&lang=ts"
export * from "./QrCodeComponentViewer.vue?vue&type=script&lang=ts"

import "./QrCodeComponentViewer.vue?vue&type=style&index=0&id=636b22f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636b22f8"]])

export default __exports__